import {DateTimePicker} from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import axios from "axios";
import {createForm} from "rc-form";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";
import {de} from "date-fns/locale";
import {type} from "os";

interface ABVersions {
    name: string;
    quantity: number;
}

interface NewFileSate {
    visible: boolean;
    errors: any;
    creatingInProgress: boolean;
    versions: ABVersions[];
    roles: string[];
}

interface NewFileProps {
    form: any;
    activeEnv: any;
    refreshData(): void;
    type: "new" | "edit";
    defaultValues: any;
    roles: string[];
}

class DashboardUserCreateWrapped extends React.Component<NewFileProps, NewFileSate> {

    constructor(props) {
        super(props);

        console.log("roles", props.roles)
        this.state = {
            visible: false,
            errors: {},
            creatingInProgress: false,
            versions: Object.keys(props.defaultValues?.pending || {}).map((key) => ({
                name: key,
                quantity: props.defaultValues.pending[key],
            })),
            roles: props.roles || [],
        };
    }

    onModalClose() {
        this.setState({visible: false});
    }

    checkValidEmail(email) {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    onModalAccept() {
        const {form} = this.props;

        form.validateFields((err, values) => {
            if (err) {
                this.setState({errors: err});
                return;
            }

            if (!this.checkValidEmail(values.email)) {
                alert("Email invalid!");
                //this.setState({ errors: {email: {errors: [{message: 'Email invalid', field: 'email'}]}}} );
                return;
            }

            if (values.password !== values.confirmpassword) {
                alert("confirmpassword not same password!");
                return;
            }

            this.setState({creatingInProgress: true}, async () => {
                try {

                    const response = await axios.post(`${Config.getInstance.apiUrl}/api/dashboard_users/create-or-update`, {
                        ...values,
                        type: this.props.type,
                        id: this.props.defaultValues?.id,
                    }, {
                        headers: {
                            Authorization: Helpers.getSessionId(),
                        },
                    });

                    this.props.refreshData();

                    this.setState({creatingInProgress: false, visible: false});
                } catch (error) {
                    this.setState({creatingInProgress: false});
                    console.error(111, error);

                    PopupMessage.error("Something went wrong!");
                }
            });
        });
    }

    showModal() {
        this.setState({visible: true});
    }

    addVersion() {
        const {versions} = this.state;

        versions.push({
            name: this.state.versions.length.toString(),
            quantity: 0,
        });

        this.setState({versions});
    }

    listVersions() {
        const {getFieldDecorator, getFieldError} = this.props.form;

        return this.state.versions.map((version, index) => (<Grid key={version.name} item xs={3} style={{marginBottom: 15}}>
            {getFieldDecorator("version_" + index,
                {
                    rules: [{
                        required: false,
                        message: "Version " + index,
                    }],
                    initialValue: version?.name || "",
                },
            )(
                <TextField
                    label="Version"
                    style={{width: "80%", marginBottom: 10}}
                    error={getFieldError("version_" + index)}
                    helperText={getFieldError("version_" + index) ? getFieldError("version_" + index).join(",") : null}
                />
            )}

            {getFieldDecorator("quantity_" + index,
                {
                    rules: [{
                        required: false,
                        message: "Quantity for version " + index,
                    }],
                    initialValue: version.quantity,
                },
            )(
                <TextField
                    label="Quantity"
                    style={{width: "80%"}}
                    error={getFieldError("quantity_" + index)}
                    helperText={getFieldError("quantity_" + index) ? getFieldError("quantity_" + index).join(",") : null}
                />
            )}
        </Grid>));
    }

    getButton(type: "new" | "edit") {
        const types = {
            new: {name: "Add New"},
            edit: {name: "Edit"},
        };

        return <Button disableElevation variant="contained" color="primary" size="small" onClick={() => this.showModal()}>
            {types[type].name}
        </Button>;
    }

    render() {
        const {getFieldDecorator, getFieldError} = this.props.form;

        const roles = this.props.roles || [];

        return (
            <React.Fragment>
                {this.getButton(this.props.type)}

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Dialog
                        open={this.state.visible}
                        onClose={() => this.onModalClose()}
                        aria-labelledby="alert-dialog-title"
                        fullWidth={true}
                        maxWidth="md"
                    >
                        <DialogTitle id="alert-dialog-title">Dashboard's User</DialogTitle>
                        <DialogContent style={{paddingTop: 10}}>
                            <Grid container spacing={3} className="marginBottom--none">
                                <Grid item xs={6}>
                                    {getFieldDecorator("username",
                                        {
                                            rules: [{
                                                required: true,
                                                message: "Please enter test Username!",
                                            }],
                                            initialValue: this.props.defaultValues?.username || "",
                                        },
                                    )(
                                        <TextField
                                            label="username"
                                            style={{width: "100%"}}
                                            error={getFieldError("username")}
                                            helperText={getFieldError("username") ? getFieldError("username").join(",") : null}
                                            size="small"
                                        />,
                                    )}
                                </Grid>

                                <Grid item xs={3}>
                                    {getFieldDecorator("password", {
                                        rules: this.props.type === 'new' ? [{
                                            required: true,
                                            message: "password of user",
                                        }] : [],
                                        //initialValue: this.props.defaultValues?.password || "",
                                        initialValue: "",
                                    },
                                    )(
                                        <TextField
                                            label="password"
                                            style={{width: "100%"}}
                                            type="password"
                                            multiline={false}
                                            error={getFieldError("password")}
                                            helperText={getFieldError("password") ? getFieldError("password").join(",") : null}
                                            size="small"
                                        />
                                    )}
                                </Grid>

                                <Grid item xs={3}>
                                    {getFieldDecorator("confirmpassword", {
                                        rules: this.props.type === 'new' ? [{
                                            required: true,
                                            message: "confirmpassword of user",
                                        }] : [],
                                        //initialValue: this.props.defaultValues?.password || "",
                                        initialValue: "",
                                    },
                                    )(
                                        <TextField
                                            label="confirm password"
                                            style={{width: "100%"}}
                                            type="password"
                                            multiline={false}
                                            error={getFieldError("confirmpassword")}
                                            helperText={getFieldError("confirmpassword") ? getFieldError("confirmpassword").join(",") : null}
                                            size="small"
                                        />
                                    )}
                                </Grid>

                                <Grid item xs={6}>
                                    {getFieldDecorator("fullname", {
                                        rules: [{
                                            required: true,
                                            message: "Full name of user",
                                        }],
                                        initialValue: this.props.defaultValues?.full_name || "",
                                    },
                                    )(
                                        <TextField
                                            label="fullname"
                                            style={{width: "100%"}}
                                            multiline={false}
                                            error={getFieldError("fullname")}
                                            helperText={getFieldError("fullname") ? getFieldError("fullname").join(",") : null}
                                            size="small"
                                        />
                                    )}
                                </Grid>

                                <Grid item xs={6}>
                                    {getFieldDecorator("email", {
                                        rules: [{
                                            required: true,
                                            message: "Email of user",
                                        }],
                                        initialValue: this.props.defaultValues?.email || "",
                                    },
                                    )(
                                        <TextField
                                            label="email"
                                            style={{width: "100%"}}
                                            multiline={true}
                                            error={getFieldError("email")}
                                            helperText={getFieldError("email") ? getFieldError("email").join(",") : null}
                                            size="small"
                                        />
                                    )}
                                </Grid>

                                <Grid item xs={3}>
                                    <FormControl>
                                        <InputLabel id="permissions-select">Permissions</InputLabel>

                                        {getFieldDecorator("permissions", {
                                            rules: [{
                                                required: true,
                                                message: "Please select permission",
                                            }],
                                            initialValue: this.props.defaultValues?.permissions || "admin",
                                        })(
                                            <Select labelId="type-permissions" autoWidth={true} size="small" style={{width: "110%"}}>
                                                <MenuItem value="admin">Admin</MenuItem>
                                                <MenuItem value="moderator">Moderator</MenuItem>
                                                <MenuItem value="superadmin">Super Admin</MenuItem>
                                            </Select>
                                        )}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={3}>
                                    <FormControl>
                                        <InputLabel id="type-select" style={{width: "100%"}}>Pageaccess</InputLabel>

                                        {getFieldDecorator("pageaccess", {
                                            rules: [{
                                                required: true,
                                                message: "Please select pageaccess",
                                            }],
                                            initialValue: this.props.defaultValues?.page_access || "ALL",
                                        })(
                                            <Select labelId="type-select" autoWidth={true} size="small" style={{width: "110%"}}>
                                                {
                                                    roles.map((role, index) => {
                                                        console.log("role", role, index)
                                                        return <MenuItem key={role.name} value={role.name}>
                                                            {role.name}
                                                        </MenuItem>
                                                    })
                                                }
                                            </Select>
                                        )}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={3}>
                                    <FormControl>
                                        <InputLabel id="type-select">Otp Enable</InputLabel>

                                        {getFieldDecorator("otpenable", {
                                            rules: [{
                                                required: true,
                                                message: "Please select otp enable",
                                            }],
                                            initialValue: this.props.defaultValues?.otp_enabled || "true",
                                        })(
                                            <Select labelId="type-select" autoWidth={true} size="small" style={{width: "110%"}}>
                                                <MenuItem value="true">true&nbsp;&nbsp;&nbsp;</MenuItem>
                                            </Select>
                                        )}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={3}>
                                    <FormControl>
                                        <InputLabel id="type-select">Otp Verified</InputLabel>

                                        {getFieldDecorator("otpverified", {
                                            rules: [{
                                                required: true,
                                                message: "Please select otp verified",
                                            }],
                                            initialValue: this.props.defaultValues?.otp_verified || "false",
                                        })(
                                            <Select labelId="type-select" autoWidth={true} size="small" style={{width: "110%"}}>
                                                <MenuItem value="false">false&nbsp;&nbsp;&nbsp;</MenuItem>
                                                <MenuItem value="true">true&nbsp;&nbsp;&nbsp;</MenuItem>
                                            </Select>
                                        )}
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                disableElevation
                                onClick={() => this.onModalClose()}
                                disabled={this.state.creatingInProgress}
                                size="small"
                                variant="outlined"
                                style={{marginRight: 10}}
                            >
                                Cancel
                            </Button>

                            <div className="loading--button-wrapper">
                                <Button
                                    disableElevation
                                    onClick={() => this.onModalAccept()}
                                    color="primary"
                                    disabled={this.state.creatingInProgress}
                                    size="small"
                                    variant="contained"
                                >
                                    Save
                                </Button>

                                {this.state.creatingInProgress && <CircularProgress size={24} className="loading--button-progress" />}
                            </div>
                        </DialogActions>
                    </Dialog>
                </LocalizationProvider>
            </React.Fragment>
        );
    }
}

export const DashboardUserCreate = createForm()(DashboardUserCreateWrapped);
